import { Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/Auth";
import { RequestsTab } from "@/components/admin/RequestsTab";
import { PhotosTab } from "@/components/admin/PhotosTab";

export default function AdminPanel() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#faf8f6]" data-testid="admin-panel">
      <header className="bg-white border-b sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/brand/sello-sm.webp" alt="" className="w-9 h-9 rounded-full object-cover" />
            <span className="font-display text-xl">La Patrona · Panel</span>
          </div>
          <div className="flex items-center gap-4 text-sm">
            <Link to="/" target="_blank" className="hidden sm:flex items-center gap-1 text-ink/60 hover:text-granate" data-testid="admin-view-site-link">Ver web <ExternalLink className="w-3.5 h-3.5" /></Link>
            <button onClick={logout} className="flex items-center gap-1 text-ink/60 hover:text-granate" data-testid="admin-logout-btn"><LogOut className="w-4 h-4" /> Salir</button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-8">
        <Tabs defaultValue="requests">
          <TabsList className="bg-white border" data-testid="admin-tabs">
            <TabsTrigger value="requests" data-testid="admin-tab-requests">Solicitudes</TabsTrigger>
            <TabsTrigger value="photos" data-testid="admin-tab-photos">Catálogo y fotos</TabsTrigger>
          </TabsList>
          <TabsContent value="requests" className="mt-6"><RequestsTab /></TabsContent>
          <TabsContent value="photos" className="mt-6"><PhotosTab /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
